import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Button } from '@outdoor-voices/ui';
import { useState } from 'react';
import PhoneInput from 'react-phone-input-labelled';
import PropTypes from 'prop-types';
import { DT } from '../../config/constants';
import { OV_CONCIERGE_API_KEY, OV_CONCIERGE_MODE, OV_CONCIERGE_OPT_IN_URL, PHONE_COUNTRIES, PHONE_DEFAULT_PLACEHOLDER, SMS_OPT_IN_DEFAULT_CONFIG, PHONE_NUMBER_LENGTH } from './constants';
import { OV_SUBSCRIBE_URL } from '../../config/theme';
import css from './EmailSMSSignUp.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Email = function Email(_ref) {
  var value = _ref.value,
      setValue = _ref.setValue;

  var onChange = function onChange(_ref2) {
    var newEmail = _ref2.target.value;
    setValue(newEmail);
  };

  return /*#__PURE__*/_jsx("label", {
    className: css.label,
    htmlFor: "email-sign-up",
    children: /*#__PURE__*/_jsx("input", {
      id: "email-sign-up",
      maxLength: 100,
      name: "email-sign-up",
      onChange: onChange,
      placeholder: "Enter Email",
      type: "email",
      value: value
    })
  });
};

Email.defaultProps = {
  value: ''
};
Email.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired
};

var SMS = function SMS(_ref3) {
  var value = _ref3.value,
      setValue = _ref3.setValue;
  var CONFIG = Object.assign(SMS_OPT_IN_DEFAULT_CONFIG, {
    orgName: 'Outdoor Voices',
    header: '',
    subheader: '',
    phonePlaceholder: 'Enter your phone number',
    // TODO: This feature doesn't work currently, contact Concierge
    buttonText: 'Submit',
    successText: '',
    formContainerStyle: {},
    buttonStyle: {},
    buttonDisabledStyle: {
      cursor: 'not-allowed'
    },
    headerStyle: {
      display: 'none'
    },
    subheaderStyle: {
      display: 'none'
    },
    phoneInputStyle: {},
    smsLegalNoticeStyle: {
      display: 'none'
    },
    smsLegalNotice: ''
  });

  var onPhoneChange = function onPhoneChange(phoneNumberValue) {
    setValue(phoneNumberValue);
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(PhoneInput, {
      defaultCountry: "us",
      disableCountryCode: true,
      disableDropdown: true,
      disableSearchIcon: true,
      enableSearchField: false,
      label: null,
      value: value,
      inputExtraProps: {
        name: 'phone',
        required: false,
        style: CONFIG.phoneInputStyle
      },
      onChange: onPhoneChange,
      placeholder: PHONE_DEFAULT_PLACEHOLDER,
      searchPlaceholder: PHONE_DEFAULT_PLACEHOLDER,
      onlyCountries: PHONE_COUNTRIES
    })
  });
};

SMS.defaultProps = {
  value: ''
};
SMS.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired
};

var EmailSMSSignUp = function EmailSMSSignUp(_ref4) {
  var klaviyoListId = _ref4.klaviyoListId,
      source = _ref4.klaviyoListSource,
      successMessage = _ref4.successMessage;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      emailValue = _useState2[0],
      setEmailValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      smsValue = _useState6[0],
      setSmsValue = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      submitted = _useState8[0],
      setSubmitted = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      submitting = _useState10[0],
      setSubmitting = _useState10[1];

  var options = {
    utm_campaign: klaviyoListId,
    mode: OV_CONCIERGE_MODE,
    pk: OV_CONCIERGE_API_KEY
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var isEmailValid, isPhoneValid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();

              if (!emailValue) {
                _context.next = 18;
                break;
              }

              isEmailValid = function isEmailValid(emailValue) {
                var matchEmail = emailValue.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
                return matchEmail && emailValue !== '';
              };

              if (isEmailValid(emailValue)) {
                _context.next = 7;
                break;
              }

              setError('Please enter a valid email address.');
              setSubmitting(false);
              return _context.abrupt("return");

            case 7:
              setSubmitting(true); // fetch

              _context.prev = 8;
              _context.next = 11;
              return fetch(OV_SUBSCRIBE_URL, {
                body: JSON.stringify({
                  email: emailValue,
                  klaviyo_list_id: klaviyoListId,
                  source: source
                }),
                headers: {
                  'Content-Type': 'application/json'
                },
                method: 'POST'
              });

            case 11:
              if (!smsValue) {
                setSubmitting(false);
                setSubmitted(true);
              }

              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](8);
              console.error(_context.t0);
              setError('There was an error submitting');

            case 18:
              if (!smsValue) {
                _context.next = 36;
                break;
              }

              isPhoneValid = function isPhoneValid(phoneNumber) {
                var matchNumbers = phoneNumber.match(/\d/g);
                return matchNumbers && matchNumbers.length === PHONE_NUMBER_LENGTH;
              };

              if (isPhoneValid(smsValue)) {
                _context.next = 24;
                break;
              }

              setError('Please enter a valid phone number.');
              setSubmitting(false);
              return _context.abrupt("return");

            case 24:
              options.phone_number = smsValue;
              setSubmitting(true);
              _context.prev = 26;
              _context.next = 29;
              return fetch(OV_CONCIERGE_OPT_IN_URL, {
                body: JSON.stringify(options),
                headers: {
                  accept: 'application/json, text/plain, */*',
                  'Content-Type': 'application/json'
                },
                method: 'POST'
              });

            case 29:
              onSuccess();
              _context.next = 35;
              break;

            case 32:
              _context.prev = 32;
              _context.t1 = _context["catch"](26);
              console.error(_context.t1);

            case 35:
              setSubmitting(false);

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 14], [26, 32]]);
    }));

    return function onSubmit(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  var onSuccess = function onSuccess() {
    setSubmitted(true);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.formWrapper,
    children: [!submitted && /*#__PURE__*/_jsxs("form", {
      className: css.form,
      onSubmit: onSubmit,
      children: [/*#__PURE__*/_jsx(Email, {
        value: emailValue,
        setValue: setEmailValue
      }), /*#__PURE__*/_jsx("span", {
        className: css.or,
        children: "or"
      }), /*#__PURE__*/_jsx(SMS, {
        value: smsValue,
        setValue: setSmsValue
      }), error && /*#__PURE__*/_jsx("p", {
        className: css.error,
        children: error
      }), /*#__PURE__*/_jsx(Button, {
        disabled: submitting || !emailValue && !smsValue,
        type: "submit",
        big: true,
        children: submitting ? DT : 'Submit'
      })]
    }), submitted && /*#__PURE__*/_jsx("p", {
      className: css.success,
      children: successMessage
    })]
  });
};

EmailSMSSignUp.defaultProps = {
  klaviyoListId: '',
  klaviyoListSource: '',
  successMessage: ''
};
EmailSMSSignUp.propTypes = {
  klaviyoListId: PropTypes.string.isRequired,
  klaviyoListSource: PropTypes.string.isRequired,
  successMessage: PropTypes.string.isRequired
};
export default EmailSMSSignUp;